export const PARAM_CONFIG = {
  /* =========================================================
   * TAB 1 – INTERVENCIÓN / CODIFICACIÓN / UBICACIÓN (Grupo 1-3)
   * ========================================================= */

  codigo: { idInfraestructura: 60, tipoDato: "Codigo", inputType: "text" },
  nombreProyecto: { idInfraestructura: 61, tipoDato: "Nombre", inputType: "text" },

  tipo: { idInfraestructura: 62, tipoDato: "Tipo", inputType: "text" },
  modalidad: { idInfraestructura: 63, tipoDato: "Modalidad", inputType: "select" }, // combo
  etapa: { idInfraestructura: 64, tipoDato: "Etapa", inputType: "select" }, // combo

  distrito: { idInfraestructura: 65, tipoDato: "Distrito", inputType: "text" },
  provincia: { idInfraestructura: 66, tipoDato: "Provincia", inputType: "text" },
  departamento: { idInfraestructura: 67, tipoDato: "Departamento", inputType: "text" },
  latitud: { idInfraestructura: 68, tipoDato: "Latitud", inputType: "text" },
  longitud: { idInfraestructura: 69, tipoDato: "Longitud", inputType: "text" },
  ubigeo: { idInfraestructura: 138, tipoDato: "Ubigeo", inputType: "text" },
  adminContrato: { idInfraestructura: 139, tipoDato: "Administrador de Contrato", inputType: "text" },
  /* estadoGeneral:  { idInfraestructura: 136, tipoDato: "Estado", inputType: "text" }, // Movido al final con TAB 12 */
  /* =========================================================
   * TAB 2 – DATOS DE LA INTERVENCIÓN (Grupo 4)
   * ========================================================= */

  cuiProyecto: { idInfraestructura: 70, tipoDato: "CUI", inputType: "text" },
  proyecto: { idInfraestructura: 71, tipoDato: "Proyecto", inputType: "text" },
  caracteristicas: { idInfraestructura: 72, tipoDato: "Caracteristicas", inputType: "textarea" },

  costoInversion: { idInfraestructura: 73, tipoDato: "Costo de inversión (S/)", inputType: "number" },
  beneficiarios: { idInfraestructura: 74, tipoDato: "Beneficiarios", inputType: "number" },
  puestos: { idInfraestructura: 75, tipoDato: "Puestos", inputType: "number" },

  areaPredio: { idInfraestructura: 76, tipoDato: "Área del predio (m2)", inputType: "number" },
  areaConstruida: { idInfraestructura: 77, tipoDato: "Área construida (m2)", inputType: "number" },
  pisos: { idInfraestructura: 78, tipoDato: "Pisos", inputType: "number" },

  administracion: { idInfraestructura: 79, tipoDato: "Administración", inputType: "text" },
  tipoMercado: { idInfraestructura: 80, tipoDato: "Tipo de Mercado", inputType: "text" },

  /* =========================================================
   * TAB 3 – CONVENIO (Grupo 5)
   * ========================================================= */

  tipoConvenio: { idInfraestructura: 81, tipoDato: "Tipo de convenio", inputType: "text" },
  estadoConvenio: { idInfraestructura: 82, tipoDato: "Estado", inputType: "text" },
  entidadConvenio: { idInfraestructura: 83, tipoDato: "Entidad", inputType: "text" },
  objetoConvenio: { idInfraestructura: 84, tipoDato: "Objeto de convenio", inputType: "text" },

  inicioVigencia: { idInfraestructura: 85, tipoDato: "Inicio de vigencia", inputType: "date" },
  plazoConvenio: { idInfraestructura: 86, tipoDato: "Plazo", inputType: "text" }, // o "number" si es días/meses numéricos
  finVigencia: { idInfraestructura: 87, tipoDato: "Fin de vigencia", inputType: "date" },

  // ✅ TAB 5 – SANEAMIENTO
  saneamiento: { idInfraestructura: 88, tipoDato: "Saneamiento", inputType: "text" },
  problematica: { idInfraestructura: 89, tipoDato: "Problemática", inputType: "text" },
  partidaRegistral: { idInfraestructura: 90, tipoDato: "Partida registral", inputType: "text" },

  // ✅ TAB 6 – PLANEAMIENTO
  opmi: { idInfraestructura: 91, tipoDato: "OPMI", inputType: "text" },

  // ✅ TAB 7 – FORMULACIÓN
  uf: { idInfraestructura: 92, tipoDato: "UF", inputType: "text" },
  intervencionForm: { idInfraestructura: 93, tipoDato: "Intervención", inputType: "text" },
  estadoForm: { idInfraestructura: 94, tipoDato: "Estado", inputType: "text" },
  costoViable: { idInfraestructura: 95, tipoDato: "Costo viable", inputType: "number" },
  fechaViabilidad: { idInfraestructura: 96, tipoDato: "Fecha de viabilidad", inputType: "date" },

  // ✅ TAB 8 – ELABORACIÓN ET
  uei: { idInfraestructura: 97, tipoDato: "UEI", inputType: "text" },
  intervencionElab: { idInfraestructura: 98, tipoDato: "Intervención", inputType: "text" },
  desarrolloElab: { idInfraestructura: 99, tipoDato: "Desarrollo", inputType: "text" },
  contratoElaboracion: { idInfraestructura: 100, tipoDato: "Contrato elaboración", inputType: "text" },
  contratistaElab: { idInfraestructura: 101, tipoDato: "Contratista", inputType: "text" },
  costoElaboracion: { idInfraestructura: 102, tipoDato: "Costo de elaboración", inputType: "number" },
  contratoSupervisionElab: { idInfraestructura: 103, tipoDato: "Contrato supervisión", inputType: "text" },
  contratistaSupervisionElab: { idInfraestructura: 104, tipoDato: "Contratista supervisión", inputType: "text" },
  costoSupervisionElab: { idInfraestructura: 105, tipoDato: "Costo de supervisión", inputType: "number" },
  estadoElab: { idInfraestructura: 106, tipoDato: "Estado", inputType: "text" },
  inicioElaboracion: { idInfraestructura: 107, tipoDato: "Inicio de elaboración", inputType: "date" },
  diasEnElaboracion: { idInfraestructura: 108, tipoDato: "Días en elaboración", inputType: "text" },
  plazoElaboracion: { idInfraestructura: 109, tipoDato: "Plazo de elaboración", inputType: "text" },
  diasRetrasoElab: { idInfraestructura: 110, tipoDato: "Días de retraso", inputType: "text" },
  fechaAprobacionElab: { idInfraestructura: 111, tipoDato: "Fecha de aprobación", inputType: "date" },

  // ✅ TAB 9 – EJECUCIÓN FÍSICA  (ESTO es lo que te falta para que pinte “EJECUCIÓN FÍSICA”)
  intervencionEjec: { idInfraestructura: 112, tipoDato: "Intervención", inputType: "text" },
  desarrolloEjec: { idInfraestructura: 113, tipoDato: "Desarrollo", inputType: "text" },
  contratoEjecucion: { idInfraestructura: 114, tipoDato: "Contrato ejecución", inputType: "text" },
  contratistaEjec: { idInfraestructura: 115, tipoDato: "Contratista", inputType: "text" },
  costoEjecucion: { idInfraestructura: 116, tipoDato: "Costo de ejecución", inputType: "number" },
  contratoSupervisionEjec: { idInfraestructura: 117, tipoDato: "Contrato supervisión", inputType: "text" },
  contratistaSupervisionEjec: { idInfraestructura: 118, tipoDato: "Contratista supervisión", inputType: "text" },
  costoSupervisionEjec: { idInfraestructura: 119, tipoDato: "Costo de supervisión", inputType: "number" },
  financiamientoObra: { idInfraestructura: 120, tipoDato: "Financiamiento de obra", inputType: "text" },
  montoFinanciado: { idInfraestructura: 121, tipoDato: "Monto financiado", inputType: "number" },
  estadoEjec: { idInfraestructura: 122, tipoDato: "Estado", inputType: "text" },
  inicioEjecucion: { idInfraestructura: 123, tipoDato: "Inicio de ejecución", inputType: "date" },
  diasEnEjecucion: { idInfraestructura: 124, tipoDato: "Días en ejecución", inputType: "text" },
  plazoEjecucion: { idInfraestructura: 125, tipoDato: "Plazo de ejecución", inputType: "text" },
  diasRetrasoEjec: { idInfraestructura: 126, tipoDato: "Días de retraso", inputType: "text" },
  fechaCulminacion: { idInfraestructura: 127, tipoDato: "Fecha de culminación", inputType: "date" },
  fechaRecepcion: { idInfraestructura: 128, tipoDato: "Fecha de recepción", inputType: "date" },

  // TAB 10 – LIQUIDACIÓN Y CIERRE
  estadoLiquidacion: { idInfraestructura: 129, tipoDato: "Estado", inputType: "text" },
  aprobacionLiquidacion: { idInfraestructura: 130, tipoDato: "Aprobación de liquidación", inputType: "text" },
  fechaCierre: { idInfraestructura: 131, tipoDato: "Fecha de cierre", inputType: "date" },
  registroCierre: { idInfraestructura: 149, tipoDato: "Registro de Cierre", inputType: "text" },

  // TAB 11 – OPERACIÓN
  inicioOperacion: { idInfraestructura: 132, tipoDato: "Inicio de operación", inputType: "date" },
  entidadAdministradora: { idInfraestructura: 133, tipoDato: "Entidad administradora", inputType: "text" },
  costoAlquilerPuesto: { idInfraestructura: 134, tipoDato: "Costo de alquiler por puesto", inputType: "number" },
  presupuestoMantenimiento: { idInfraestructura: 135, tipoDato: "Presupuesto de mantenimiento", inputType: "number" },

  // TAB 12 – ESTADO / HITO
  estadoGeneral: { idInfraestructura: 136, tipoDato: "Estado", inputType: "text" },
  hito: { idInfraestructura: 137, tipoDato: "Hito", inputType: "text" },
  mercadoContingencia: { idInfraestructura: 157, tipoDato: "Mercado de Contingencia", inputType: "text" },
  otrosDesc: { idInfraestructura: 152, tipoDato: "Otros (Descripción)", inputType: "text" },
  otrosEjec: { idInfraestructura: 154, tipoDato: "Otros (Ejecución)", inputType: "text" },
  otrosET: { idInfraestructura: 158, tipoDato: "Otros (Expediente)", inputType: "text" },
  elaboradoExp: { idInfraestructura: 159, tipoDato: "Elaborado Por (Expediente)", inputType: "text" },
  elaboradoPreinv: { idInfraestructura: 161, tipoDato: "Elaborado Por (Preinversión)", inputType: "text" },

  // --- NUEVOS CAMPOS DE AVANCE Y VALORIZADO ---
  avanceSaneamiento: { idInfraestructura: 140, tipoDato: "Avance (%)", inputType: "number" },
  avanceForm:        { idInfraestructura: 141, tipoDato: "Avance (%)", inputType: "number" },
  
  montoAcumuladoElab: { idInfraestructura: 142, tipoDato: "Monto Acumulado de Valorizado", inputType: "number" },
  avanceElab:         { idInfraestructura: 143, tipoDato: "Avance (%)", inputType: "number" },
  
  montoAcumuladoEjec: { idInfraestructura: 144, tipoDato: "Monto Acumulado de Valorizado", inputType: "number" },
  avanceEjec:         { idInfraestructura: 145, tipoDato: "Avance (%)", inputType: "number" },
  
  avanceLiq:  { idInfraestructura: 146, tipoDato: "Avance (%)", inputType: "number" },
  avanceOper: { idInfraestructura: 147, tipoDato: "Avance (%)", inputType: "number" },
  fechaActualizacion: { idInfraestructura: 162, tipoDato: "Fecha de Actualización", inputType: "date" },
};



/*
export const PARAM_CONFIG = {
  // TAB 1 – INTERVENCIÓN
  codigo:             { idInfraestructura: 60, tipoDato: "Codigo" },
  nombreProyecto:  { idInfraestructura: 61, tipoDato: "Nombre" },
  tipo:            { idInfraestructura: 62, tipoDato: "Tipo" },
  modalidad:       { idInfraestructura: 63, tipoDato: "Modalidad" },
  etapa:           { idInfraestructura: 64, tipoDato: "Etapa" },

  // TAB 3 – UBICACIÓN
  distrito:        { idInfraestructura: 65, tipoDato: "Distrito" },
  provincia:       { idInfraestructura: 66, tipoDato: "Provincia" },
  departamento:    { idInfraestructura: 67, tipoDato: "Departamento" },
  latitud:         { idInfraestructura: 68, tipoDato: "Latitud" },
  longitud:        { idInfraestructura: 69, tipoDato: "Longitud" },
  ubigeo:          { idInfraestructura: 138, tipoDato: "Ubigeo" },

  // TAB 3 – DATOS DE LA INTERVENCIÓN
  cuiProyecto:         { idInfraestructura: 70, tipoDato: "CUI" },
  proyecto:            { idInfraestructura: 71, tipoDato: "Proyecto" },
  caracteristicas:     { idInfraestructura: 72, tipoDato: "Caracteristicas" },
  costoInversion:      { idInfraestructura: 73, tipoDato: "Costo de inversión (S/)" },
  beneficiarios:       { idInfraestructura: 74, tipoDato: "Beneficiarios" },
  puestos:             { idInfraestructura: 75, tipoDato: "Puestos" },
  areaPredio:          { idInfraestructura: 76, tipoDato: "Área del predio (m2)" },
  areaConstruida:      { idInfraestructura: 77, tipoDato: "Área construida (m2)" },
  pisos:               { idInfraestructura: 78, tipoDato: "Pisos" },
  administracion:      { idInfraestructura: 79, tipoDato: "Administración" },
  tipoMercado:         { idInfraestructura: 80, tipoDato: "Tipo de mercado" },

  // TAB 4 – CONVENIO
  tipoConvenio:        { idInfraestructura: 81, tipoDato: "Tipo de convenio" },
  estadoConvenio:      { idInfraestructura: 82, tipoDato: "Estado" },
  entidadConvenio:     { idInfraestructura: 83, tipoDato: "Entidad" },
  objetoConvenio:      { idInfraestructura: 84, tipoDato: "Objeto de convenio" },
  inicioVigencia:      { idInfraestructura: 85, tipoDato: "Inicio de vigencia" },
  plazoConvenio:       { idInfraestructura: 86, tipoDato: "Plazo" },
  finVigencia:         { idInfraestructura: 87, tipoDato: "Fin de vigencia" },

  // TAB 5 – SANEAMIENTO
  saneamiento:         { idInfraestructura: 88, tipoDato: "Saneamiento" },
  problematica:        { idInfraestructura: 89, tipoDato: "Problemática" },
  partidaRegistral:    { idInfraestructura: 90, tipoDato: "Partida registral" },

  // TAB 6 – PLANEAMIENTO
  opmi:                { idInfraestructura: 91, tipoDato: "OPMI" },

  // TAB 7 – FORMULACIÓN
  uf:                  { idInfraestructura: 92, tipoDato: "UF" },
  intervencionForm:    { idInfraestructura: 93, tipoDato: "Intervención" },
  estadoForm:          { idInfraestructura: 94, tipoDato: "Estado" },
  costoViable:         { idInfraestructura: 95, tipoDato: "Costo viable" },
  fechaViabilidad:     { idInfraestructura: 96, tipoDato: "Fecha de viabilidad" },

  // TAB 8 – ELABORACIÓN ET
  uei:                      { idInfraestructura: 97, tipoDato: "UEI" },
  intervencionElab:         { idInfraestructura: 98, tipoDato: "Intervención" },
  desarrolloElab:           { idInfraestructura: 99, tipoDato: "Desarrollo" },
  contratoElaboracion:      { idInfraestructura: 100, tipoDato: "Contrato elaboración" },
  contratistaElab:          { idInfraestructura: 101, tipoDato: "Contratista" },
  costoElaboracion:         { idInfraestructura: 102, tipoDato: "Costo de elaboración" },
  contratoSupervisionElab:  { idInfraestructura: 103, tipoDato: "Contrato supervisión" },
  contratistaSupervisionElab:{ idInfraestructura: 104, tipoDato: "Contratista supervisión" },
  costoSupervisionElab:     { idInfraestructura: 105, tipoDato: "Costo de supervisión" },
  estadoElab:               { idInfraestructura: 106, tipoDato: "Estado" },
  inicioElaboracion:        { idInfraestructura: 107, tipoDato: "Inicio de elaboración" },
  diasEnElaboracion:        { idInfraestructura: 108, tipoDato: "Días en elaboración" },
  plazoElaboracion:         { idInfraestructura: 109, tipoDato: "Plazo de elaboración" },
  diasRetrasoElab:          { idInfraestructura: 110, tipoDato: "Días de retraso" },
  fechaAprobacionElab:      { idInfraestructura: 111, tipoDato: "Fecha de aprobación" },

  // TAB 9 – EJECUCIÓN FÍSICA
  intervencionEjec:         { idInfraestructura: 112, tipoDato: "Intervención" },
  desarrolloEjec:           { idInfraestructura: 113, tipoDato: "Desarrollo" },
  contratoEjecucion:        { idInfraestructura: 114, tipoDato: "Contrato ejecución" },
  contratistaEjec:          { idInfraestructura: 115, tipoDato: "Contratista" },
  costoEjecucion:           { idInfraestructura: 116, tipoDato: "Costo de ejecución" },
  contratoSupervisionEjec:  { idInfraestructura: 117, tipoDato: "Contrato supervisión" },
  contratistaSupervisionEjec:{ idInfraestructura: 118, tipoDato: "Contratista supervisión" },
  costoSupervisionEjec:     { idInfraestructura: 119, tipoDato: "Costo de supervisión" },
  financiamientoObra:       { idInfraestructura: 120, tipoDato: "Financiamiento de obra" },
  montoFinanciado:          { idInfraestructura: 121, tipoDato: "Monto financiado" },
  estadoEjec:               { idInfraestructura: 122, tipoDato: "Estado" },
  inicioEjecucion:          { idInfraestructura: 123, tipoDato: "Inicio de ejecución" },
  diasEnEjecucion:          { idInfraestructura: 124, tipoDato: "Días en ejecución" },
  plazoEjecucion:           { idInfraestructura: 125, tipoDato: "Plazo de ejecución" },
  diasRetrasoEjec:          { idInfraestructura: 126, tipoDato: "Días de retraso" },
  fechaCulminacion:         { idInfraestructura: 127, tipoDato: "Fecha de culminación" },
  fechaRecepcion:           { idInfraestructura: 128, tipoDato: "Fecha de recepción" },

  // TAB 10 – LIQUIDACIÓN Y CIERRE
  estadoLiquidacion:        { idInfraestructura: 129, tipoDato: "Estado" },
  aprobacionLiquidacion:    { idInfraestructura: 130, tipoDato: "Aprobación de liquidación" },
  fechaCierre:              { idInfraestructura: 131, tipoDato: "Fecha de cierre" },

  // TAB 11 – OPERACIÓN
  inicioOperacion:          { idInfraestructura: 132, tipoDato: "Inicio de operación" },
  entidadAdministradora:    { idInfraestructura: 133, tipoDato: "Entidad administradora" },
  costoAlquilerPuesto:      { idInfraestructura: 134, tipoDato: "Costo de alquiler por puesto" },
  presupuestoMantenimiento: { idInfraestructura: 135, tipoDato: "Presupuesto de mantenimiento" },

  // TAB 12 – ESTADO / HITO
  estadoGeneral:            { idInfraestructura: 136, tipoDato: "Estado" },
  hito:                     { idInfraestructura: 137, tipoDato: "Hito" },
};
*/
// src/config/mercadoParametrosConfig.js

const SUBITEMS = {
  EJECUTADAS: "ejecutadas",
  EN_EJECUCION: "en ejecucion",
  MONITOREO_GL: "monitoreo (ejecucion GL)",
  IOARR: "ioarr",
  EXP_TEC: "expediente tecnico",
  PERFIL: "perfil",
};

// Secciones armadas a partir de las keys de PARAM_CONFIG
export const SECCIONES = [
  {
    titulo: "Intervención",
    keys: ["cui", "nombreProyecto", "tipo", "modalidad", "etapa"],
    col: "left",
    showIn: [
      SUBITEMS.EJECUTADAS,
      SUBITEMS.EN_EJECUCION,
      SUBITEMS.MONITOREO_GL,
      SUBITEMS.IOARR,
      SUBITEMS.EXP_TEC,
      SUBITEMS.PERFIL,
    ],
  },
  {
    titulo: "Ubicación",
    keys: ["departamento", "provincia", "distrito", "latitud", "longitud"],
    col: "left",
    showIn: [
      SUBITEMS.EJECUTADAS,
      SUBITEMS.EN_EJECUCION,
      SUBITEMS.MONITOREO_GL,
      SUBITEMS.IOARR,
      SUBITEMS.EXP_TEC,
      SUBITEMS.PERFIL,
    ],
  },

  {
    titulo: "Datos de la intervención",
    keys: [
      "cuiProyecto",
      "proyecto",
      "caracteristicas",
      "costoInversion",
      "beneficiarios",
      "puestos",
      "areaPredio",
      "areaConstruida",
      "pisos",
      "administracion",
      "tipoMercado",
    ],
    col: "left",
    showIn: [
      SUBITEMS.EJECUTADAS,
      SUBITEMS.EN_EJECUCION,
      SUBITEMS.MONITOREO_GL,
      SUBITEMS.IOARR,
      SUBITEMS.EXP_TEC,
      SUBITEMS.PERFIL,
    ],
  },

  // Estas puedes mostrarlas solo en "en proyecto" (perfil/expediente)
  {
    titulo: "Convenio",
    keys: [
      "tipoConvenio",
      "estadoConvenio",
      "entidadConvenio",
      "objetoConvenio",
      "inicioVigencia",
      "plazoConvenio",
      "finVigencia",
    ],
    col: "left",
    showIn: [SUBITEMS.EXP_TEC, SUBITEMS.PERFIL, SUBITEMS.EN_EJECUCION, SUBITEMS.MONITOREO_GL, SUBITEMS.IOARR],
  },

  {
    titulo: "Saneamiento",
    keys: ["saneamiento", "problematica", "partidaRegistral"],
    col: "left",
    showIn: [SUBITEMS.EXP_TEC, SUBITEMS.PERFIL], // si en ejecutadas ya no interesa
  },

  {
    titulo: "Planeamiento",
    keys: ["opmi"],
    col: "left",
    showIn: [SUBITEMS.EXP_TEC, SUBITEMS.PERFIL],
  },

  {
    titulo: "Formulación",
    keys: ["uf", "intervencionForm", "estadoForm", "costoViable", "fechaViabilidad"],
    col: "left",
    showIn: [SUBITEMS.EXP_TEC, SUBITEMS.PERFIL],
  },

  {
    titulo: "Elaboración ET",
    keys: [
      "uei",
      "intervencionElab",
      "desarrolloElab",
      "contratoElaboracion",
      "contratistaElab",
      "costoElaboracion",
      "contratoSupervisionElab",
      "contratistaSupervisionElab",
      "costoSupervisionElab",
      "estadoElab",
      "inicioElaboracion",
      "diasEnElaboracion",
      "plazoElaboracion",
      "diasRetrasoElab",
      "fechaAprobacionElab",
    ],
    col: "right", // contractual a la derecha (similar a tu UI)
    showIn: [SUBITEMS.EXP_TEC],
  },

  {
    titulo: "Ejecución física",
    keys: [
      "intervencionEjec",
      "desarrolloEjec",
      "contratoEjecucion",
      "contratistaEjec",
      "costoEjecucion",
      "contratoSupervisionEjec",
      "contratistaSupervisionEjec",
      "costoSupervisionEjec",
      "financiamientoObra",
      "montoFinanciado",
      "estadoEjec",
      "inicioEjecucion",
      "diasEnEjecucion",
      "plazoEjecucion",
      "diasRetrasoEjec",
      "fechaCulminacion",
      "fechaRecepcion",
    ],
    col: "right",
    showIn: [SUBITEMS.EN_EJECUCION, SUBITEMS.MONITOREO_GL, SUBITEMS.IOARR],
  },

  {
    titulo: "Liquidación y cierre",
    keys: ["estadoLiquidacion", "aprobacionLiquidacion", "fechaCierre", "registroCierre"],
    col: "left",
    showIn: [SUBITEMS.EJECUTADAS], // SOLO ejecutadas
  },

  {
    titulo: "Operación",
    keys: ["inicioOperacion", "entidadAdministradora", "costoAlquilerPuesto", "presupuestoMantenimiento"],
    col: "left",
    showIn: [SUBITEMS.EJECUTADAS], // si solo aplica cuando ya operan
  },

  {
    titulo: "Estado / Hito",
    keys: ["estadoGeneral", "hito"],
    col: "left",
    showIn: [
      SUBITEMS.EJECUTADAS,
      SUBITEMS.EN_EJECUCION,
      SUBITEMS.MONITOREO_GL,
      SUBITEMS.IOARR,
      SUBITEMS.EXP_TEC,
      SUBITEMS.PERFIL,
    ],
  },
];

// mercadoDetalleLayouts.js
export const MERCADO_DETALLE_LAYOUTS = {
  1: { // EJECUTADA
    header: {
      titulo: {
        label: "PROYECTO",
        idInfraestructura: 71, // proyecto / nombre visible
      },
      fechaActualizacion: {
        idInfraestructura: null, // vacío por ahora
      },
    },

    izquierda: [
      {
        label: "UBICACIÓN",
        fields: [
          { idInfraestructura: 67 }, // departamento
          { idInfraestructura: 66 }, // provincia
          { idInfraestructura: 65 }, // distrito
        ],
        join: "-",
      },
      {
        label: "UBIGEO",
        idInfraestructura: 138,
      },
      {
        label: "TIPO",
        idInfraestructura: 80, // tipo de mercado (MINORISTA)
      },
      {
        label: "CUI",
        idInfraestructura: 70,
      },
      {
        label: "ENTREGA DE OBRA",
        idInfraestructura: 128, // fechaRecepcion
      },
      {
        label: "N° PUESTOS",
        idInfraestructura: 75,
      },
      {
        label: "COSTO DE INVERSIÓN",
        idInfraestructura: 73,
        format: "currency",
      },
      {
        label: "BENEFICIARIOS",
        idInfraestructura: 74,
      },
      {
        label: "UNIDAD FORMULADORA",
        idInfraestructura: 92, // UF
      },
      {
        label: "UNIDAD EJECUTORA DE INVERSIONES",
        idInfraestructura: 97, // UEI
      },
      {
        label: "ESTADO",
        idInfraestructura: 136, // estado general
      },
    ],

    derecha: {
      imagen: {
        enabled: true,
        source: "endpoint-imagenes", // placeholder
      },
      coordenadas: [
        { label: "Latitud", idInfraestructura: 68 },
        { label: "Longitud", idInfraestructura: 69 },
      ],
    },

    footer: {
      label: "CARACTERÍSTICAS DEL PROYECTO",
      idInfraestructura: 72,
      button: {
        label: "Ayuda Memoria",
        action: "download", // luego lo conectas
      },
    },
  },
};
